import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import Toggle from './Toggle';
import { Link } from 'react-router-dom';
import StatusIcon from '../../StatusIcon';
import { miniDisclaimer } from 'constants/values';

export const SeriesCard = ({
  name,
  submitted,
  inCart,
  inCartString,
  remainingQuota,
  totalQuota,
  remainingString,
  selected,
  seriesId,
  submittedString,
  stylesArrow,
  stylesNameSize,
  stylesCarImageSize,
  stylesRoot,
  imgUrl,
  modelUrl,
  mini,
  addDisclaimer,
}) => (
  <div className={stylesRoot}>
    <div className={styles.seriesCard}>
      <Link to={modelUrl}>
        <div className={styles.seriesVisuals}>
          <span className={stylesNameSize}>{name}</span>
          <img alt="cosy-series" className={stylesCarImageSize} src={imgUrl} />
          <div className={styles.statusIndicator}>
            <StatusIcon submitted={submitted} totalQuota={totalQuota} />
          </div>
          {addDisclaimer && (
            <div className={styles.disclaimer}>{miniDisclaimer}</div>
          )}
        </div>
      </Link>
      <div className={styles.seriesData}>
        <span className={styles.dataSummary}>
          <span
            className={
              remainingQuota === 0 ? styles.dataPointInactive : styles.dataPoint
            }
          >
            {remainingQuota}
          </span>
          <p className={mini ? styles.dataMiniLabel : styles.dataLabel}>
            {remainingString}
          </p>
        </span>
        <span className={styles.dataSummary}>
          <span
            className={
              submitted === 0 ? styles.dataPointInactive : styles.dataPoint
            }
          >
            {submitted}
          </span>
          <p className={mini ? styles.dataMiniLabel : styles.dataLabel}>
            {submittedString}
          </p>
        </span>
        <span className={styles.dataSummary}>
          <span
            className={
              inCart === 0 ? styles.dataPointInactive : styles.dataPoint
            }
          >
            {inCart}
          </span>
          <p className={mini ? styles.dataMiniLabel : styles.dataLabel}>
            {inCartString}
          </p>
        </span>
        <Toggle seriesId={seriesId} selected={selected} />
      </div>
    </div>
    <span className={stylesArrow} />
  </div>
);

export default enhance(SeriesCard);
